import { z } from "zod";

export const DISCOVERY_DECADES = [
  { label: "50s", startYear: 1950, endYear: 1959 },
  { label: "60s", startYear: 1960, endYear: 1969 },
  { label: "70s", startYear: 1970, endYear: 1979 },
  { label: "80s", startYear: 1980, endYear: 1989 },
  { label: "90s", startYear: 1990, endYear: 1999 },
  { label: "00s", startYear: 2000, endYear: 2009 },
  { label: "10s", startYear: 2010, endYear: 2019 },
  { label: "20s", startYear: 2020, endYear: 2029 },
] as const;

export type DiscoveryDecade = (typeof DISCOVERY_DECADES)[number]["startYear"];

const DISCOVERY_DECADE_STARTS = new Set<number>(
  DISCOVERY_DECADES.map((decade) => decade.startYear),
);

export const discoveryDecadeSchema: z.ZodType<DiscoveryDecade> = z
  .number()
  .int()
  .refine(
    (value): value is DiscoveryDecade => DISCOVERY_DECADE_STARTS.has(value),
    "Unsupported discovery decade",
  );

export function isDiscoveryDecade(value: number): value is DiscoveryDecade {
  return DISCOVERY_DECADE_STARTS.has(value);
}
